import Api from '@/services/Api'
// import { log } from 'util';

export default {
  index(query) {
    return Api().get(`mainledgerlla`, {params: query})
  },
  choose(query) {
    return Api().get(`mainledgerlla/choose`, {
      params: query
    })
  },
  card(query) {
    return Api().get(`mainledgerlla/card`, {
      params: query
    })
  },
  // povijesna kartica sredstva po sredstvu (llaID = Sifra int.) kroz sve godine
  kartica(query) {
    return Api().get(`mainledgerlla/kartica`, {
      params: query
    })
  },
  // zbirno po AOP oznaci (llaCode)
  karticaAop(query) {
    return Api().get(`mainledgerlla/kartica/aop`, {
      params: query
    })
  },
  // provjera obracuna amortizacije za sva sredstva firme
  provjera(query) {
    return Api().get(`mainledgerlla/provjera`, {
      params: query
    })
  },
  // popis sredstava firme (jedan redak po llaID) i AOP oznaka za odabir kartice
  karticaPopis(query) {
    return Api().get(`mainledgerlla/kartica/popis`, {
      params: query
    })
  },
  show(mainledgerllaid) {
    return Api().get(`mainledgerlla/${mainledgerllaid}`)
  },
  post(newmainledgerlla) {
    return Api().post('mainledgerlla', newmainledgerlla)
  },
  put(mainledgerlla) {
    return Api().put(`mainledgerlla/${mainledgerlla.id}`, mainledgerlla)
  },
  delete(databaseMLID) {
    return Api().delete(`mainledgerlla/${databaseMLID}`)
  },
  saveitems(items) {
    if (items) {
      return Api().post('mainledgerlla/saveitems', items)
    }
    return
  },
}